import {
  FETCH_CUSTOMER_PENDING,
  FETCH_CUSTOMER_REJECTED,
  FETCH_CUSTOMER_FULFILLED,
  REMOVE_CUSTOMER_DETAIL
} from "../constants/customerDetail";
import { FETCH_TOKEN_REJECTED, FETCH_TOKEN_FULFILLED } from "../constants/signin";

const initialState = {
  pending: true,
  customer: {},
  error: {},
  redirect: false
};

export const customerDetail = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CUSTOMER_PENDING:
      return { ...state, pending: true, error: {}, redirect: false };

    case FETCH_CUSTOMER_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_CUSTOMER_FULFILLED:
      return {
        ...state,
        customer: action.response,
        pending: false,
        error: {}
      };

    case FETCH_TOKEN_REJECTED:
      return { 
        ...state,
        pending: false,
        error: action.error
      };

    case FETCH_TOKEN_FULFILLED:
      return {
        ...state,
        pending: false,
        redirect: true,
        error: {}
      };

    case REMOVE_CUSTOMER_DETAIL:
      return {
        ...state,
        customer: {}
      }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/customerDetail.js